import { Node } from "@tiptap/core";
import {
  NodeViewContent,
  NodeViewWrapper,
  ReactNodeViewRenderer,
} from "@tiptap/react";

const Component = () => {
  return (
    <NodeViewWrapper>
      <NodeViewContent />
    </NodeViewWrapper>
  );
};

export const IgnoreBlock = Node.create({
  name: "ignore_block",
  content: "text*",
  group: "inline",
  inline: true,
  renderHTML() {
    return ["div", 0];
  },
  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
});
